export const requestInterval = function (fn, delay) {
  var start = new Date().getTime(),
    handle = {}

  function loop() {
    var current = new Date().getTime(),
      delta = current - start

    if (delta >= delay) {
      fn.call()
      start = new Date().getTime()
    }

    handle.value = requestAnimationFrame(loop)
  }

  handle.value = requestAnimationFrame(loop)
  return handle
}

export const clearRequestInterval = function (handle) {
  cancelAnimationFrame(handle.value)
}
